import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, AppBar, Tabs, Tab, Typography } from "@mui/material";
import CategoriesScreen from "../ui/blog/components/CategoriesScreen";
import AllTipsScreen from "../ui/blog/components/AllTipsScreen";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PWAHeader from "../common/PWAHeader";

const Fsn117HealthyReads = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleBackButtonPress = () => {
    if (window.Android) {
      // Call Android's Java function via the bridge
      window.Android.onBackPressed();
    } else {
      console.log("Back button pressed (no Android bridge available)");
      navigate(-1);
    }
  };

  useEffect(() => {
    // Attach the back button handler
    const backHandler = () => {
      handleBackButtonPress();
      return false; // Prevent default back navigation
    };

    window.addEventListener("popstate", backHandler);

    return () => {
      window.removeEventListener("popstate", backHandler);
    };
  }, []);

  return (
    <>

      <PWAHeader title={"Health Blogs"} onBack={handleBackButtonPress} />

      <Box sx={{ maxWidth: 800, margin: "0 auto" }}>
        <AppBar position="static" sx={{ backgroundColor: "#fff" }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            // textColor="primary"
            variant="fullWidth"
            sx={{
              background: "linear-gradient(90deg, #fff 0%, rgba(255, 152, 0, 0.11) 100%)",
              // Customize indicator
              "& .MuiTabs-indicator": {
                backgroundColor: "#771615", // Change indicator color
                height: 3 // Optional: customize indicator thickness
              },
              // Customize tab text
              "& .MuiTab-root": {
                color: "#666", // Default text color
                fontWeight: "normal",
                "&.Mui-selected": {
                  color: "#fff", // Selected tab text color
                  // fontWeight: "bold",
                  background: "linear-gradient(90deg, #771615 0%, #771615 100%)", // Selected tab background
                  // Optional: to make text visible on dark background
                  "& span": {
                    color: "#fff"
                  }
                }
              }
            }}
          >
            <Tab label="Categories" />
            <Tab label="All Tips" />
            {/* <Tab label="Bookmarks" /> */}
          </Tabs>
        </AppBar>

        {activeTab === 0 && <CategoriesScreen />}
        {activeTab === 1 && <AllTipsScreen />}
        {/* {activeTab === 2 && <BookmarksScreen />} */}
      </Box>
    </>
  );
};

export default Fsn117HealthyReads;